<div *ngIf="aberta" class="modal-backdrop-custom" (click)="fechar.emit()">
  <div class="modal-card modal-acerto" (click)="$event.stopPropagation()">
    <div class="modal-header-custom">
      <h3 class="h5 mb-0">Acerto de ponto</h3>
      <button type="button" class="btn btn-light btn-sm" (click)="fechar.emit()" aria-label="Fechar">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body-custom">
      <p class="text-secondary small">
        Recusas corretas (departamento, janela, 30s, slot ocupado, face) ficam ignoradas.
        Marque so os candidatos. Confirmar grava a batida no horario da tentativa na auditoria.
      </p>

      <div *ngIf="carregando" class="text-secondary">Montando preview...</div>

      <ng-container *ngIf="!carregando && preview">
        <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
          <h4 class="h6 mb-0">Candidatos ({{ preview.candidatos.length }})</h4>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="preview.candidatos.length === 0 || confirmando"
            (click)="marcarTodos()">
            Marcar todos
          </button>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            [disabled]="selecionados.size === 0 || confirmando"
            (click)="limparSelecao()">
            Limpar selecao
          </button>
        </div>
        <div class="table-responsive" *ngIf="preview.candidatos.length > 0; else semCandidatos">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th></th>
                <th>Servidor</th>
                <th>Tentativa</th>
                <th>Batida</th>
                <th>Motivo atual</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of preview.candidatos">
                <td>
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="marcado(item.eventoId)"
                    [disabled]="confirmando"
                    (change)="alternar(item.eventoId, $any($event.target).checked)">
                </td>
                <td>{{ item.matricula }} - {{ item.nome }}</td>
                <td class="text-nowrap">{{ hora(item) }}</td>
                <td>{{ item.numeroBatidaSugerida || '-' }}</td>
                <td>{{ item.motivoAtual }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #semCandidatos>
          <p class="text-secondary small">Nenhum candidato. As falhas do periodo sao recusas corretas ou nao elegiveis.</p>
        </ng-template>

        <details class="secao-ignorados">
          <summary class="h6 mb-0">Ignorados ({{ preview.ignorados.length }})</summary>
          <div class="table-responsive lista-ignorados" *ngIf="preview.ignorados.length > 0">
            <table class="table table-sm align-middle">
              <thead>
                <tr>
                  <th>Servidor</th>
                  <th>Tentativa</th>
                  <th>Situacao</th>
                  <th>Motivo</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of preview.ignorados">
                  <td>{{ item.matricula || '-' }} {{ item.nome ? '- ' + item.nome : '' }}</td>
                  <td class="text-nowrap">{{ hora(item) }}</td>
                  <td>{{ item.situacao }}</td>
                  <td>{{ item.motivoAtual }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </details>
      </ng-container>
    </div>

    <div class="modal-footer-custom">
      <button type="button" class="btn btn-outline-secondary" (click)="fechar.emit()" [disabled]="confirmando">Fechar</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="selecionados.size === 0 || confirmando || carregando"
        (click)="confirmarSelecionados()">
        {{ confirmando ? 'Gravando' : 'Confirmar selecionados' }}
      </button>
    </div>
  </div>
</div>
